import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

/**
 * Created by h3 on 2018-09-10.
 */

export class FruitsTextStyles {
    static BONUS_INTRO_SCATTER:TextStyleOptions = {
        align : "center",
        fontFamily : "Open Sans",
        fontSize : 30,
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.SEMI_BOLD,
        fill : "#ffffff",
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : 90 * PIXI.DEG_TO_RAD,
        dropShadowBlur : 2,
        dropShadowColor : "#330033",
        dropShadowDistance : 2,
        padding : 10,
        wordWrap : true,
        wordWrapWidth : 400
    };

    static BONUS_INTRO:TextStyleOptions = {
        align : "center",
        fontFamily : "Open Sans",
        fontSize : 30,
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.SEMI_BOLD,
        fill : "#ffffff",
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : 90 * PIXI.DEG_TO_RAD,
        dropShadowBlur : 2,
        dropShadowColor : "#330033",
        dropShadowDistance : 2,
        padding : 10
    };

    static BONUS_INTRO_WW:TextStyleOptions = {
        align : "right",
        fontFamily : "Open Sans",
        fontSize : 30,
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.SEMI_BOLD,
        fill : "#ffffff",
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : 90 * PIXI.DEG_TO_RAD,
        dropShadowBlur : 2,
        dropShadowColor : "#330033",
        dropShadowDistance : 2,
        padding : 10,
        wordWrap : true,
        wordWrapWidth : 250
    };

    static BONUS_OUTRO_TOT_WIN:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontWeight : FontWeight.SEMI_BOLD,
        fontStyle : FontStyle.ITALIC,
        fontSize : "50px",
        fill : [
            "#ffff00",
            "#33CC00"
        ],
        stroke : "#99ff00",
        strokeThickness : 2,
        align : "center",
        lineJoin : "round",
        dropShadow : true,
        dropShadowAngle : 90 * PIXI.DEG_TO_RAD,
        dropShadowBlur : 8,
        dropShadowDistance : 3,

    };

}
